export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қалпына келтіру"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Барлығын таңдау"])}
}